import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  getHasResults,
  getSelectedFolder,
  getStudioParams,
} from '../../../selectors/studio';
import { getSubfolders } from '../../../selectors/published';
import { AppState } from '../../../types/store';
import { Props } from './FolderHeaderDesktop';

export type StateProps = Pick<
  Props,
  'selectedFolder' | 'subfolders' | 'hasDeviations' | 'activeQuery'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const selectedFolder = getSelectedFolder(state)!;
  const hasDeviations = getHasResults(state);

  return {
    selectedFolder,
    hasDeviations,
    subfolders: getSubfolders(state),
    activeQuery: getStudioParams(state).searchQuery,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
